// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wp-edit-link":"_1OjZa7"};